import CountBadge from '../components/messenger/CountBadge'


export default {
    main:[
        {
            label: 'Dashboard',
            icon: ['fal','home-alt'],
            name: 'Dashboard'
        },
        {
            label: 'Add Post',
            icon: ['fal','plus'],
            name:'Add'
        },
        {
            label: 'Explore',
            icon: ['fal','compass'],
            name:'Blogs'
        },
        {
            label: 'Top 20',
            icon: ['fal','chart-line'],
            name:'Charts'
        },
        {
            label: 'Messenger',
            icon: ['fal','comments'],
            name:'Messenger',
            component: CountBadge
        },
        {
            label: 'Profile',
            icon: ['fal', 'user'],
            name:'TopProfile', // Need to get uniqe Name fpr DropdownMenu
            subs: [
              {
                label: 'Profile',
                icon: ['fal', 'user'],
                name:'Profile',
              },
              {
                label: 'My Blogs',
                icon: ['fal', 'atlas'],
                name:'MyBlogs'
              },
              {
                label: 'Followed Blogs',
                icon: ['fal', 'user-friends'],
                name: 'FollowedBlogs'
              },
            ]
        }
    ]
}



// WEBPACK FOOTER //
// ./src/store/Navigation.js